"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BillingListItem = class BillingListItem extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getContainer(...args) {
        return {
            self: this.$fn.urlFor('create_billing_list_item'),
            object: 'list',
            data: []
        };
    }
    getPayload(...args) {
        const [editor] = args;
        const exclude = [];
        return editor.isNew ?
            editor.getData({ exclude }) :
            editor.getChanges({ exclude, skipEmbeddedLists: true });
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    templateParams;
    onTemplate_params(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("templateParams");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    messages;
    resource;
    async $$load_resource() {
        return this.oid
            ? this.$fn.fetch('read_billing_list_item', { parameters: { id: this.oid }, asResource: true })
            : this.$fn.fetch('get_billing_list_item_template', { parameters: this.templateParams, asResource: true });
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'formName', 'messages', 'resource', 'editor', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "billingListItem",
                messages: {
                    createTitle: this.$fn.pgettext("BillingListItem", "New billing list item"),
                },
                resource: null,
                editor: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get isDeletable() {
        if (this.loaded) {
            return this.oid != null;
        }
        return null;
    }
    get editTitle() {
        if (this.loaded) {
            return this.resource.description;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.resource.isNew ? this.messages.createTitle : this.messages.editTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2100_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_reloadSlickgrid_2108_getActionArgs($event) {
        return {
            grid: "billingListItem",
        };
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_emit_2112_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data,
        };
    }
    async act_1040167445267876_closeComponent_2114_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_rest_2110_getActionArgs($event) {
        return {
            method: "save",
            container: this.getContainer(this.editor),
            resource: this.editor,
            data: this.getPayload(this.editor),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_5534025912102772_reload(event, scope) {
        return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
    }
    async evh_5534025912102772_close(event, scope) {
        return await this.actions.evh_5534025912102772_close.executeFromDOM(this, event, scope);
    }
    async act_5534025912102772_emit_2120_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data,
        };
    }
    async evh_5534025912102772_changed(event, scope) {
        return await this.actions.evh_5534025912102772_changed.executeFromDOM(this, event, scope);
    }
    async evh_2167826738365259_clickPreventStop(event, scope) {
        return await this.actions.evh_2167826738365259_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2100 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2100_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2099 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2100,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2099],
        });
        const act_2248226175642056_closeComponent_2102 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2101 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2102,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2101],
        });
        const act_8564662037462133_reloadComponentData_2104 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_2103 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_2104,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_2103],
        });
        const act_8564662037462133_closeComponent_2106 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_8564662037462133_deleted_2105 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeComponent_2106,
            event: "deleted",
            displayName: "closeComponent",
        });
        const act_8564662037462133_reloadSlickgrid_2108 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8564662037462133_reloadSlickgrid_2108_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_deleted_2107 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadSlickgrid_2108,
            event: "deleted",
            displayName: "reloadSlickgrid",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_2105, evh_8564662037462133_deleted_2107],
        });
        const act_1040167445267876_emit_2112 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_2112_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_2111 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_2112,
            event: "saved",
            displayName: "emit",
        });
        const act_1040167445267876_closeComponent_2114 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_2114_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_2113 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_2114,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_rest_2110 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_2110_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_saved_2111, evh_1040167445267876_saved_2113],
        });
        const evh_1040167445267876_submit_2109 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_2110,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_2109],
        });
        const act_5534025912102772_reloadComponentData_2116 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5534025912102772_reload_2115 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_reloadComponentData_2116,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_5534025912102772_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_reload_2115],
        });
        const act_5534025912102772_closeComponent_2118 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_5534025912102772_close_2117 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_closeComponent_2118,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_5534025912102772_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_close_2117],
        });
        const act_5534025912102772_emit_2120 = new core_1.actions.EmitAction({
            actionArgs: this.act_5534025912102772_emit_2120_getActionArgs,
            events: [],
        });
        const evh_5534025912102772_changed_2119 = new core_1.actions.EventHandlerImpl({
            action: act_5534025912102772_emit_2120,
            event: "changed",
            displayName: "emit",
        });
        const evh_5534025912102772_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5534025912102772_changed_2119],
        });
        const act_2167826738365259_closeComponent_2122 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2167826738365259_clickPreventStop_2121 = new core_1.actions.EventHandlerImpl({
            action: act_2167826738365259_closeComponent_2122,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_2167826738365259_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2167826738365259_clickPreventStop_2121],
        });
        return {
            act_7315092382398562_closeModal_2100,
            evh_7315092382398562_close_2099,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2102,
            evh_2248226175642056_close_2101,
            evh_2248226175642056_close,
            act_8564662037462133_reloadComponentData_2104,
            evh_8564662037462133_reload_2103,
            evh_8564662037462133_reload,
            act_8564662037462133_closeComponent_2106,
            evh_8564662037462133_deleted_2105,
            act_8564662037462133_reloadSlickgrid_2108,
            evh_8564662037462133_deleted_2107,
            evh_8564662037462133_deleted,
            act_1040167445267876_emit_2112,
            evh_1040167445267876_saved_2111,
            act_1040167445267876_closeComponent_2114,
            evh_1040167445267876_saved_2113,
            act_1040167445267876_rest_2110,
            evh_1040167445267876_submit_2109,
            evh_1040167445267876_submit,
            act_5534025912102772_reloadComponentData_2116,
            evh_5534025912102772_reload_2115,
            evh_5534025912102772_reload,
            act_5534025912102772_closeComponent_2118,
            evh_5534025912102772_close_2117,
            evh_5534025912102772_close,
            act_5534025912102772_emit_2120,
            evh_5534025912102772_changed_2119,
            evh_5534025912102772_changed,
            act_2167826738365259_closeComponent_2122,
            evh_2167826738365259_clickPreventStop_2121,
            evh_2167826738365259_clickPreventStop,
            save: act_1040167445267876_rest_2110,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], BillingListItem.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingListItem.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], BillingListItem.prototype, "templateParams", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('templateParams'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingListItem.prototype, "onTemplate_params", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BillingListItem.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BillingListItem.prototype, "onSize", null);
BillingListItem = __decorate([
    (0, vue_property_decorator_1.Component)()
], BillingListItem);
exports.default = BillingListItem;
vue_property_decorator_1.Vue.component("BillingListItem", BillingListItem);
